import { createSelector } from "@reduxjs/toolkit"
import { SharedAppState } from "shared/state/store.shared";

const selectRecipes = (store: SharedAppState) => store.recipe.recipes;

export const selectIsSkioldDigitalRecipes = createSelector(selectRecipes, (recipes) => {
    // do something with a, b, and c, and return a result
    return recipes.filter(recipe => recipe.isSkioldDigitalRecipe);
  })